import React from 'react';
import { StubLabel } from 'Components/Texts';

export const InputField = ({
  value = '',
  isDisabled = false,
  error,
  handleChange,
  onBlur,
  className = '',
  touched,
  isInvalidZip, //unused?
  label,
  autofocus,
  ariaLabel,
  autoComplete,
  name,
  warn,
  maxlength,
  placeholder,
  optionalTextPos,
  optionField,
  optionalSuccessMark,
  type = 'text', // other types include "tel"
}) => {
  const warning = warn && false; //no func here yet like in PasswordField.js

  error = isInvalidZip ? 'Invalid zip' : error;
  let inputClassName = `formFieldInput ${touched && error ? 'inputError' : ''}`;
  inputClassName = value ? `${inputClassName} hasValue` : inputClassName;

  // optionalTextPos will be either inline or belowField, if it is inline, we need to put it in label (placeholder)
  const labelText = optionalTextPos === 'inline' ? `${label} (optional)` : label;

  const labelId = label && !ariaLabel ? `input-${label.replace(/\s+/g, '')}` : null;

  //onDragStart, onDrop, onFocus?

  return (
    <div className={`formField ${className}`}>
      <div className="animatedFieldContainer">
        <input
          className={inputClassName}
          onChange={handleChange}
          onBlur={onBlur}
          value={value}
          maxLength={maxlength}
          placeholder={placeholder}
          type={type}
          name={name}
          autoComplete={autoComplete}
          autoFocus={autofocus}
          disabled={isDisabled}
          aria-label={ariaLabel}
          aria-labelledby={labelId}
        />
        {label && <StubLabel text={labelText} id={labelId} className="animatedLabel" />}
        {
          // if it is touched, not an optinal field and there is error or warning, show fieldError or Warning message
          touched &&
            !optionField &&
            ((error && <div className="formFieldError">{error}</div>) ||
              (warning && <div className="formFieldWarning ">{warning}</div>))
        }
        {
          /**
           * if optionField is set to true and optional text position is belowField, show optional text below field
           */
          optionField && optionalTextPos === 'belowField' && <div className="optionalText ">*optional</div>
        }
        {optionalSuccessMark && <span className="icon-checkmark" />}
      </div>
    </div>
  );
};
